import React, { Fragment, useEffect, useState } from "react";
import { useHistory } from "react-router";
import { Link } from "react-router-dom";
// import { useNavigate } from "react-router-dom";
import parse from "html-react-parser";
import { useForm } from "react-hook-form";
import BreachExposure from "../../../Assets/images/Breach_Exclamation_Icon.svg";
import {
    getBreachById,
    savePremiumBreachesByBreachId,
    removePremiumBreachesByBreachId,
    archiveDetectedBreachesByBreachId,
    completeBreachAction,
    setActionStep,
} from "../../../store/service";
import MagnifyIcon from "../../../Assets/images/breach_search_magnify.svg";
import BreachGraph from "../BreachGraph";
import CollapseInfo from "../CollapseInfo";
import { graphColor, detailPage } from "../BreachConstants";
import { DialogComponent } from "../../common/DialogComponent";
import BreachRiskRatingInfo from "../RiskRating/BreachRiskRatingInfo";
import InfoIcon from "../../../Assets/images/icon-info-circle.svg";
import { Notification } from "../../common/Notification";
import BreachHeaderText from "../BreachHeaderText";
import BreachesTab from "../BreachesTab";
import BreachInfoDialog from "../BreachInfoDialog";
import { useDispatch, useSelector } from "react-redux";
import { ApplicationState } from "../../../store";
import * as ConfigurationActions from "../../../store/configurationService/actions";
import { breachServiceActive } from "../../../util/CommonBreach";
import BreachOpenCaseConfirmation from "../BreachOpenCaseConfirmation";
import BreachArchiveConfirmation from "../BreachArchiveConfirmation";
import * as BreachActions from "../../../store/breachService/actions";
import BreachActionComplete from "../ActionPlan/BreachActionComplete";
import * as alertActions from "../../../store/AlertsService/actions";
import { getFormattedDate } from "../../../util/dateFormatting";
import i18nService from "../../../util/Internationalization/i18n/i18n";
import LogoContainer from "../../common/LogoContainer";
import RenderIcons from "../../../Assets/css/_icons/partner_icon/RenderIcons";
interface IBreachDialogState {
    saveBreachOpen: boolean;
    removeBreachOpen: boolean;
    affectedDataOpen: boolean;
}

function BreachDetails(props: any) {
    const history = useHistory();
    const dispatch = useDispatch();
    const breachService = useSelector((state: ApplicationState) => (state.breachServiceState ? state.breachServiceState.breachService : null));
    const routeLoading = useSelector((state: ApplicationState) => state.configurationState && (state.configurationState.loading || false));
    const [isLoading, setIsLoading] = useState(true);
    const [breachDetail, setBreachDetail] = useState<any>({});
    const [isRiskDialogOpen, setIsRiskDialogOpen] = useState(false);
    const [dialogDetail, setDialogDetail] = useState<IBreachDialogState>({
        saveBreachOpen: false,
        removeBreachOpen: false,
        affectedDataOpen: false,
    });
    const [isBreachSaved, setIsBreachSaved] = useState(false);
    const [confirmOpenCaseDialog, setConfirmOpenCaseDialog] = useState(false);
    const [confirmArchiveDialog, setConfirmArchiveDialog] = useState(false);
    const [alertItem, setAlertItem] = useState([]);
    const [isBodyNull, setIsBodyNull] = useState(false);
    const [isViewed, setIsViewed] = useState(false);
    const [isActionComplete, setIsActionComplete] = useState(false);
    const [active, setActive] = useState("");
    const [actions, setActions] = useState<any>({
        completeActions: [],
        pendingActions: [],
        simpleActions: [],
    });
    const isBusinessUser = useSelector((state: ApplicationState) =>
        state.loggedInUser && state.loggedInUser.userServiceDetails && state.loggedInUser.userServiceDetails.isBusinessUser
            ? state.loggedInUser.userServiceDetails.isBusinessUser
            : false
    );
    const requestAlertData = (reload: boolean) => dispatch(alertActions.actionCreators.getAlertData(isBusinessUser, reload));
    const { register, handleSubmit, errors, clearErrors } = useForm({
        mode: "onSubmit",
        reValidateMode: "onSubmit",
    });

    let searchKey = ((props.location && props.location.state && props.location.state.search) as any) || ({} as any);
    let orgName = ((props.location && props.location.state && props.location.state.orgName) as any) || ({} as any);
    let nullDataBreachDate = ((props.location && props.location.state && props.location.state.breachDate) as any) || ({} as any);
    const backPage = ((props.location && props.location.state && props.location.state.backPage) as any) || ({} as any);
    const onSubmit = (values: any) => {
        if (values.search) {
            searchKey = values.search;
            history.push({
                pathname: `/breaches/search-breaches-results`,
                state: { search: values.search },
            });
        }
    };

    const onSave = () => {
        setIsLoading(true);
        savePremiumBreachesByBreachId({
            BreachIDs: [breachDetail.breachID],
            Source: 1,
        }).then((res) => {
            setIsLoading(false);
            if (res.isSuccess) {
                setIsBreachSaved(true);
                getBreachDetail();
                Notification({
                    type: "success",
                    title: "Save Breach",
                    message: "Breach successfully saved.",
                });
            } else {
                Notification({
                    type: "error",
                    title: "Save Breach",
                    message: "We are facing issue to save breach, please try again later.",
                });
            }
        });
    };

    const onRemoveBreach = () => {
        setIsLoading(true);
        removePremiumBreachesByBreachId({
            BreachIDs: [breachDetail.breachID],
            Source: 1,
        }).then((res) => {
            setIsLoading(false);
            if (res.isSuccess) {
                setIsBreachSaved(false);
                getBreachDetail();
                Notification({
                    type: "success",
                    title: "Remove Breach",
                    message: "Breach successfully removed.",
                });
            } else {
                Notification({
                    type: "error",
                    title: "Remove Breach",
                    message: "We are facing issue to remove breach, please try again later.",
                    duration: 5,
                });
            }
        });
    };
    const handleArchive = (breachStatus: string, status: string, noBreachDetailCall?: boolean) => {
        setIsLoading(true);
        let reqData = {
            breachId: breachDetail && breachDetail.breachID,
            breachStatus,
            alertItemRequest: [
                {
                    status,
                    alertId: alertItem[0]["alertId"],
                    serviceType: alertItem[0]["serviceType"],
                },
            ],
        };
        archiveDetectedBreachesByBreachId(reqData)
            .then((res) => {
                setIsLoading(false);
                if (res.isSuccess) {
                    requestAlertData(true);
                    if (breachStatus === "VIEWED") {
                        dispatch(BreachActions.actionCreators.requestBreachSummary());
                    }
                    if (breachStatus === "ARCHIVE") {
                        Notification({
                            type: "success",
                            title: "Archive",
                            message: "Archived successfully.",
                            duration: 5,
                        });
                    }
                    if (breachStatus === "OPEN-CASE") {
                        Notification({
                            type: "success",
                            title: "OPEN CASE",
                            message: "Case opened successfully.",
                            duration: 5,
                        });
                    }

                    if (breachStatus === "RE-OPEN-CASE") {
                        Notification({
                            type: "success",
                            title: "REOPEN CASE",
                            message: "Case reopened successfully.",
                            duration: 5,
                        });
                    }
                    if (breachStatus === "OPEN-CASE-RESOLVED") {
                        Notification({
                            type: "success",
                            title: "RESOLVE CASE",
                            message: "Case resolved successfully.",
                            duration: 5,
                        });
                    }
                    if (!noBreachDetailCall) {
                        getBreachDetail();
                    }
                }
            })
            .catch((err) => {
                Notification({
                    type: "error",
                    title: "Alert Case",
                    message: "We are facing issue technical issue, please try again later.",
                    duration: 5,
                });
            });
    };

    const backToSearchResult = () => {
        if (backPage === "breach_search") {
            history.push({
                pathname: `/breaches/search-breaches-results`,
                state: { search: searchKey },
            });
        } else {
            history.push({
                pathname: `${detailPage[backPage]["backLink"]}`,
            });
        }
    };

    let ifBreachDetail = Object.keys(breachDetail).length;
    const getBreachDetail = () => {
        const id = ((props.location && props.location.state.id) as any) || ({} as any);
        if (id) {
            getBreachById({ id: String(id) }).then((res) => {
                setIsLoading(false);
                if (res.body === null) {
                    setIsBodyNull(true);
                }
                if (res.isSuccess) {
                    if (res.alertItemRequest) {
                        setAlertItem(res.alertItemRequest);
                    }
                    setBreachDetail(res.body);
                    setIsBreachSaved(res.body.inSavedBreachList);
                    let completed: any = [];
                    let incomplete: any = [];
                    let simpleAction: any = [];
                    if (res.body && res.body.actionList) {
                        res.body.actionList.forEach((item: any) => {
                            if (item.completed) {
                                completed.push(item);
                            }
                            if (item.completed === null && item.fiActionQueueIdList && item.fiActionQueueIdList.length) {
                                incomplete.push(item);
                            }
                            if (
                                item.completed === null &&
                                ((item.fiActionQueueIdList && item.fiActionQueueIdList.length === 0) || item.fiActionQueueIdList === null)
                            ) {
                                simpleAction.push(item);
                            }
                        });
                        setActions({
                            completeActions: completed,
                            pendingActions: incomplete,
                            simpleActions: simpleAction,
                        });
                    }
                }
                setConfirmOpenCaseDialog(false);
                setConfirmArchiveDialog(false);
            });
        } else {
            backToSearchResult();
            setIsLoading(false);
        }
    };

    useEffect(() => {
        getBreachDetail();
        if (routeLoading) {
            dispatch(ConfigurationActions.actionCreators.setRouteLoading(false));
        }
    }, []);

    useEffect(() => {
        if (Object.keys(breachDetail).length && alertItem.length && alertItem[0]["status"] === "NEW" && !isViewed) {
            handleArchive("VIEWED", "NEW", true);
            setIsViewed(true);
        }
        if (Object.keys(breachDetail).length && breachDetail.dectectedBreachStatus && breachDetail.dectectedBreachStatus === "NEW") {
            handleArchive("VIEWED", "", true);
            setIsViewed(true);
        }
    }, [alertItem, breachDetail]);

    const closeDialog = () => {
        setIsRiskDialogOpen(false);
    };
    const closeActionDialog = () => {
        setIsActionComplete(false);
    };
    const closeSaveBreachDialog = () => {
        setDialogDetail({ ...dialogDetail, saveBreachOpen: false });
    };
    const closeRemoveBreachDialog = () => {
        setDialogDetail({ ...dialogDetail, removeBreachOpen: false });
    };
    const closeAffectedDataBreachDialog = () => {
        setDialogDetail({ ...dialogDetail, affectedDataOpen: false });
    };
    const handleOpenCaseCloseDialog = () => {
        setConfirmOpenCaseDialog(false);
    };
    const handleArchiveCloseDialog = () => {
        setConfirmArchiveDialog(false);
    };

    const getSaveBreachInfo = () => {
        return (
            <>
                <div className="col-xs-2 col-sm-1"></div>
                <div className="col-xs-8 col-sm-10">
                    <p className="risk-rating-description">
                        You should save a breach to your history if you believe that your information was exposed in the breach. You may have found out about this
                        incident through a notification letter you received or through news coverage of the breach.
                    </p>
                </div>
            </>
        );
    };

    const getRemoveBreachInfo = () => {
        return (
            <>
                <div className="col-xs-2 col-sm-1"></div>
                <div className="col-xs-8 col-sm-10">
                    <p className="risk-rating-description">
                        You should remove a saved breach if you learn that your information was not exposed in the breach or if you accidentally saved a breach you
                        were not affected by. Even if you have completed all the recommended actions for a breach, keeping it in your history lets us help you
                        understand any future risks you may face from this incident.
                    </p>
                </div>
            </>
        );
    };

    const getAffectedDataBreachInfo = () => {
        return (
            <>
                <div className="col-xs-2 col-sm-1"></div>
                <div className="col-xs-8 col-sm-10">
                    <p className="risk-rating-description">
                        This section includes a list of likely exposed record types for those affected by the associated breach.
                    </p>
                </div>
                <div className="row">
                    <div className="col-xs-2 col-sm-1"></div>
                    <div className="col-xs-8 col-sm-10">
                        <p className="risk-rating-description">
                            If you have been notified by the organization that your information has been exposed in the breach, or have received an alert that your
                            information was found on the dark web as result of this breach, then your personal data has been affected. Otherwise, your information
                            may or may not have been exposed by the breach.
                        </p>
                    </div>
                </div>
            </>
        );
    };

    const renderSaveRemoveBreach = () => {
        return (
            <>
                <div
                    className="row between-xs"
                    style={
                        isBreachSaved
                            ? {
                                backgroundColor: "#ebf6ed",
                                padding: "0.15rem 1.5rem",
                                alignItems: "center",
                            }
                            : {
                                backgroundColor: "#e6f0f3",
                                padding: "0.15rem 1.5rem",
                                alignItems: "center",
                            }
                    }
                >
                    <div className="saved-title col-xs col-no-gutter flex-grow-null">
                        <h4>BREACH</h4>
                        {isBreachSaved && (
                            <div className="breach-save-title-container">
                                <span className="onboarding-task-icon">
                                    <em className="las la-check-circle"></em>
                                </span>
                                <span className="breach-save-title">SAVED TO MY BREACH HISTORY</span>
                            </div>
                        )}
                    </div>
                    <div className="col-xs col-no-gutter flex-grow-null">
                        <Link
                            to="/"
                            className="default_link"
                            style={{ padding: "1rem 1rem 1rem 0px" }}
                            onClick={(e: any) => {
                                e.preventDefault();
                            }}
                        >
                            {isBreachSaved ? (
                                <span
                                    onClick={() => {
                                        setDialogDetail({
                                            ...breachDetail,
                                            removeBreachOpen: true,
                                        });
                                    }}
                                >
                                    {" "}
                                    When should I remove a saved breach?
                                </span>
                            ) : (
                                <span
                                    onClick={() => {
                                        setDialogDetail({
                                            ...breachDetail,
                                            saveBreachOpen: true,
                                        });
                                    }}
                                >
                                    {" "}
                                    When should I save a breach?
                                </span>
                            )}
                        </Link>
                        {isBreachSaved ? (
                            <button
                                className="btn-default btn-secondary-outline btn-bg-color breach-btn"
                                onClick={(e: any) => {
                                    e.preventDefault();
                                    onRemoveBreach();
                                    window.addToDataLayer({ event: "breachIQBtnRemoveSavedBreach" });
                                }}
                            >
                                <span className="btn-text">Remove from Saved Breaches</span>
                            </button>
                        ) : (
                            <button
                                className="btn-default btn-secondary-outline btn-bg-color breach-btn"
                                onClick={(e: any) => {
                                    e.preventDefault();
                                    onSave();
                                    window.addToDataLayer({ event: "breachIQBtnSaveBreach" });
                                }}
                            >
                                <span className="btn-text">Save Breach</span>
                            </button>
                        )}
                    </div>
                </div>
            </>
        );
    };

    const renderDetectedBreach = () => {
        return (
            <>
                <div
                    className="row between-xs"
                    style={{
                        backgroundColor: "#f9fcfd",
                        padding: "0.4375rem 1.5rem",
                        alignItems: "center",
                    }}
                >
                    <div className="saved-title col-xs col-no-gutter flex-grow-null">
                        <h4>BREACH</h4>

                        {ifBreachDetail && breachDetail.inDetectedBreachList && (
                            <div className="breach-save-title-container">
                                <span className="onboarding-task-icon" style={{ paddingRight: "5px", color: "#0a7087" }}>
                                    <em className="las la-check-circle"></em>
                                </span>
                                <span className="breach-detected-title">DETECTED EXPOSURE</span>
                            </div>
                        )}
                    </div>

                    {alertItem.length && alertItem[0]["status"] === "NEW" ? (
                        <div className="col-xs col-no-gutter flex-grow-null">
                            <button
                                className="btn-default btn-secondary-outline"
                                style={{ marginRight: "0.9375rem", backgroundColor: "#f9fcfd" }}
                                onClick={(e: any) => {
                                    e.preventDefault();
                                    setConfirmArchiveDialog(true);
                                }}
                            >
                                <span className="btn-text" style={{ color: "#0a7087" }}>
                                    Archive in Alerts
                                </span>
                            </button>

                            <button
                                className="btn-default btn-secondary-outline"
                                style={{ backgroundColor: "#f9fcfd" }}
                                onClick={(e: any) => {
                                    e.preventDefault();
                                    setConfirmOpenCaseDialog(true);
                                }}
                            >
                                <span className="btn-text" style={{ color: "#0a7087" }}>
                                    Open a Case
                                </span>
                            </button>
                        </div>
                    ) : null}

                    {alertItem.length && alertItem[0]["status"] !== "NEW" ? (
                        <div className="col-xs col-no-gutter flex-grow-null">
                            {alertItem[0]["status"] === "MINE" && (
                                <button
                                    className="btn-default btn-secondary-outline"
                                    onClick={(e: any) => {
                                        e.preventDefault();
                                        setConfirmOpenCaseDialog(true);
                                    }}
                                    style={{ backgroundColor: "#f9fcfd" }}
                                >
                                    <span className="btn-text" style={{ color: "#0a7087" }}>
                                        Open a Case
                                    </span>
                                </button>
                            )}

                            {alertItem[0]["status"] === "NOT_MINE_RESOLVED" && (
                                <button
                                    className="btn-default btn-secondary-outline"
                                    onClick={(e: any) => {
                                        e.preventDefault();
                                        setConfirmOpenCaseDialog(true);
                                    }}
                                    style={{ backgroundColor: "#f9fcfd" }}
                                >
                                    <span className="btn-text" style={{ color: "#0a7087" }}>
                                        Reopen Case
                                    </span>
                                </button>
                            )}

                            {alertItem[0]["status"] === "NOT_MINE" && (
                                <button
                                    className="btn-default btn-secondary-outline"
                                    onClick={(e: any) => {
                                        e.preventDefault();
                                        setConfirmOpenCaseDialog(true);
                                    }}
                                    style={{ backgroundColor: "#f9fcfd" }}
                                >
                                    <span className="btn-text" style={{ color: "#0a7087" }}>
                                        Resolve Case
                                    </span>
                                </button>
                            )}
                        </div>
                    ) : null}
                </div>
            </>
        );
    };

    const handleCompleteAction = (currentActionIndex: any, externalData?: any) => {
        let fiActionIds: any = [];
        let id = 0;
        let name = "";
        if (actions.pendingActions.length) {
            actions.pendingActions[currentActionIndex]["fiActionQueueIdList"].forEach((fiId: any) => {
                fiActionIds.push(parseInt(fiId));
            });
            id = actions.pendingActions[currentActionIndex]["id"];
            name = actions.pendingActions[currentActionIndex]["name"];
        }
        let reqData = { fiActionQueueId: fiActionIds, id, name };
        setActionStep({
            actionFiQueueId: reqData.fiActionQueueId,
            actionId: reqData.id,
            actionName: reqData.name,
            actionStepLabel: externalData && externalData.label ? externalData.label : "Mark Action as Complete",
        });
        if (externalData && externalData.externalLink) {
            setIsLoading(true);
            getBreachDetail();
            window.open(externalData.externalLink, "_blank");
        } else if (externalData && externalData.internalLink) {
            history.push(externalData.internalLink);
        } else {
            setIsLoading(true);
            completeBreachAction(reqData)
                .then((res) => {
                    setIsLoading(false);
                    if (res.isSuccess) {
                        getBreachDetail();
                        setIsActionComplete(true);
                        setActive("");
                    } else {
                        Notification({
                            type: "error",
                            title: "Action Complete",
                            message: "We are facing issue to complete action, please try again later.",
                            duration: 5,
                        });
                    }
                })
                .catch((err: any) => {
                    setIsLoading(false);
                    Notification({
                        type: "error",
                        title: "Action Complete",
                        message: "We are facing issue to complete action, please try again later.",
                        duration: 5,
                    });
                });
        }
    };

    const takeActionOptions = {
        replace: (option: any) => {
            if (option && option.name === "ol" && option.children && option.children.length > 0) {
                return (
                    <ol style={{ listStyle: "inside", padding: "10px 0px" }}>
                        {option.children.map((item: any, i: number) => (item.name === "li" ? <li key={i}>{item.children[0] && item.children[0].data}</li> : null))}
                    </ol>
                );
            }
            if (option && option.name === "ul" && option.children && option.children.length > 0) {
                return (
                    <ol style={{ listStyle: "inside", padding: "10px 0px" }}>
                        {option.children.map((item: any, i: number) => (item.name === "li" ? <li key={i}>{item.children[0] && item.children[0].data}</li> : null))}
                    </ol>
                );
            }
        },
    };
    const convertLink = (str: string) => {
        const regex = /\[([^\]]+)\]\(([^)]+)\)/;
        const match = str.match(regex);
        if (match) {
            const text = match[1];
            const link = match[2];
            const matchIndex = match.index !== undefined ? match.index : 0;
            str = `${str.substring(0, matchIndex)}[<a href="${link}" target="_blank">${text}</a>]${str.substring(matchIndex + match[0].length)}`;
        }
        return str;
    };
    const additionalOption = {
        replace: (option: any) => {
            if (option.type === "text") {
                return <div>{parse(convertLink(option.data), {})}</div>;
            }
        },
    };
    const renderContent = (v: any, index: number) => {
        const { content = {} } = v;
        return (
            <div className="pending-action" style={{ marginBottom: 0 }}>
                {content && content.description && (
                    <div className="content-title">
                        <span style={{ fontSize: "1.125rem", marginRight: "0.5rem" }}>
                            <RenderIcons iconName="question-circle" />
                        </span>
                        <h5>What is This</h5>
                    </div>
                )}
                {content && content.description && <div className="content-desc">{parse(content.description, {})}</div>}
                {content && content.image && (
                    <div className="content-desc">
                        <img src={content.image} style={{ maxHeight: "120px" }} />
                    </div>
                )}
                {content && content.takeAction && (
                    <div>
                        <div className="content-title" style={{ marginBottom: 8 }}>
                            <span style={{ fontSize: "1.125rem", marginRight: "0.5rem" }}>
                                <RenderIcons iconName="clipboard-list" />
                            </span>
                            <h5>How to take this action:</h5>
                        </div>
                        <div className="content-action">{parse(content.takeAction, takeActionOptions)}</div>
                    </div>
                )}
                {content && content.additionalResource && (
                    <div>
                        <div className="data-grid has-lines"></div>
                        <div className="content-title" style={{ marginBottom: 11, marginTop: " 1rem" }}>
                            <span style={{ fontSize: "1.125rem", marginRight: "0.5rem" }}>
                                <RenderIcons iconName="link" />
                            </span>
                            <h5>Additional Resources:</h5>
                        </div>
                        {content.additionalResource.map((item: string, i: number) => (
                            <div key={i}>{parse(item, additionalOption)}</div>
                        ))}
                    </div>
                )}
            </div>
        );
    };

    return (
        <Fragment>
            <div className="row">
                {!breachServiceActive(breachService) ? (
                    <div className="col-xs-12 row">
                        <h1 className="title-page" id="breach-details-heading1" tabIndex={-1} style={{ color: "#00313c" }}>
                            Breach Search
                        </h1>
                        <LogoContainer internalPage={true} />
                    </div>
                ) : (
                    <BreachHeaderText />
                )}
            </div>

            <BreachesTab selectedTab={detailPage[backPage]["selectedTab"]} />

            <div className="row middle-xs">
                <div className="result-back-arrow-box">
                    <span
                        className="btn-icon cursor-pointer"
                        style={{ width: "1.5rem" }}
                        onClick={() => {
                            backToSearchResult();
                        }}
                    >
                        <em className="las la-angle-left breach-back-arrow-icon"></em>
                    </span>
                </div>
                <div className="col-xs">
                    <Link
                        to="/"
                        className="default_link"
                        onClick={(e: any) => {
                            e.preventDefault();
                            backToSearchResult();
                        }}
                    >
                        <h3 className="title-page" id="breach-details-heading3" tabIndex={-1}>
                            {backPage === "breach_exposure"
                                ? "Back to Breach Exposures"
                                : backPage === "breach_case" || backPage === "breach_alert"
                                    ? "Back to Alerts"
                                    : "Back to Search Results"}
                        </h3>
                    </Link>
                </div>
            </div>

            <div className={isLoading ? "row loading" : "row"} id="content">
                <div className="col-xs">
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <label htmlFor="search-breach" className="hide-label">
                            Enter the name of the breached organization...
                        </label>
                        <div className="form-input input-card search-detail-page-container" style={{ textAlign: "center" }}>
                            <input
                                type="text"
                                className="inputbox input-breach-search"
                                name="search"
                                id="search-breach"
                                placeholder="Enter the name of the breached organization..."
                                ref={register({ required: true, minLength: 3 })}
                                onChange={(e) => {
                                    if (e.target.value.length >= 3) {
                                        clearErrors("search");
                                    }
                                }}
                            />
                            <button
                                type="submit"
                                id="btn-search-breach"
                                className="btn-default btn-search-bg-color padding-right-s search-btn-search-breach display-flex-justify-center-align-center btn-primary"
                                onClick={() => window.addToDataLayer({ event: "breachIQBtnSearch" })}
                            >
                                <img src={MagnifyIcon} alt="Magnifying Glass" />
                                <span className="btn-text btn-search-text padding-left-xs">Search</span>
                            </button>
                        </div>
                    </form>
                    {!!errors["search"] && errors["search"].type === "minLength" && (
                        <div className="error-breach-search search-detail-page-container">
                            <span className="error-icon">
                                <em className="las la-exclamation-triangle font-error"></em>
                            </span>
                            <span style={{ textAlign: "initial" }}>Please enter at least three characters in search bar.</span>
                        </div>
                    )}

                    {!isBodyNull && breachServiceActive(breachService) && !breachDetail.inDetectedBreachList ? renderSaveRemoveBreach() : null}
                    {!isBodyNull && breachServiceActive(breachService) ? (breachDetail.inDetectedBreachList ? renderDetectedBreach() : null) : null}

                    <div className="box">
                        <div className="box-header padding-left-3rem">
                            <div className="box-title-container" style={{ marginBottom: "0px" }}>
                                <div className="box-title-icon top-20" aria-hidden="true">
                                    <img src={BreachExposure} alt="Folder with an exclamation point in the center" />
                                </div>

                                <div className="box-title-text flex-row" style={{ alignItems: "center" }}>
                                    <h1 className="box-title">{ifBreachDetail ? breachDetail.organizationName : orgName}</h1>
                                    <h2 style={{ color: "#00748d", fontWeight: 300, lineHeight: "1.5" }}>
                                        {ifBreachDetail
                                            ? getFormattedDate(i18nService.get("Country"), breachDetail.dateOfBreach)
                                            : getFormattedDate(i18nService.get("Country"), nullDataBreachDate)}
                                    </h2>
                                </div>
                            </div>
                        </div>

                        {isBodyNull ? (
                            <div className="box-description breach-detail-null">
                                <div className="row row-container">
                                    <div className="col-xs-12 col-sm-11 text-align-center col-main-na">
                                        <div className="icon-main">
                                            <span className="na-icon">N/A</span>
                                        </div>
                                        <div>
                                            <div className="title-main">Details for this breach are not available at this time.</div>
                                            <div className="description">
                                                '{orgName}' has not disclosed enough details for us to determine the risks to victims' identities and accounts.
                                                Please check this breach at a later time for updates.
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-sm-1" style={{ background: "#fff" }}></div>
                                </div>
                            </div>
                        ) : null}
                    </div>

                    {!isBodyNull ? (
                        <div className="row">
                            <div className="col-xs-12 col-sm-7 padding-btm-1 pd-l pd-unset">
                                <div className="box" style={{ padding: "0px 2rem" }}>
                                    <div className="box-header padding-top-m">
                                        <div className="box-title-container flex" style={{ alignItems: "center" }}>
                                            <div className="box-title-text">
                                                <h2 className="result-match">Breach Risk Score</h2>
                                            </div>
                                            <button
                                                className="header-button title-icon flex"
                                                style={{ cursor: "pointer" }}
                                                onClick={() => {
                                                    setIsRiskDialogOpen(true);
                                                }}
                                                id="risk-btn"
                                            >
                                                <img
                                                    src={InfoIcon}
                                                    className="img-info-icon"
                                                    alt="Circle with the letter 'i' in the center, signifying information"
                                                />
                                            </button>
                                        </div>
                                    </div>
                                    <div className="score-wrapper padding-right-xxl">
                                        <div className="box-content">
                                            {ifBreachDetail ? (
                                                <div className={`card-wrapper ${graphColor[breachDetail.score]["cardBg"]}`}>
                                                    <div className={`risk-value ${graphColor[breachDetail.score]["textColor"]}`}>{breachDetail.score}</div>
                                                    <div
                                                        className={graphColor[breachDetail.score]["textColor"]}
                                                        style={{ paddingLeft: "1rem", textAlign: "center" }}
                                                    >
                                                        <div className="risk-type">{graphColor[breachDetail.score]["text"]}</div>
                                                        <p className="risk-from">({breachDetail.score} of 10)</p>
                                                    </div>
                                                </div>
                                            ) : null}
                                        </div>
                                        <div>
                                            <BreachGraph active={breachDetail.score} />
                                        </div>
                                    </div>

                                    <div className="padding-top-xxl">
                                        <h2 className="result-match">What are my top risks?</h2>
                                        <p style={{ fontSize: "12px", padding: "1rem 0px" }}>
                                            If your data was compromised in this breach, we've listed the top threats to your identity in order of risk priority,
                                            specific to this breach.{" "}
                                        </p>
                                        <CollapseInfo
                                            headers={
                                                ifBreachDetail
                                                    ? breachDetail.harmList.map((v: any, i: number) => <Fragment key={`${v.id}-${i}`}>{v.name}</Fragment>)
                                                    : []
                                            }
                                        >
                                            {ifBreachDetail ? breachDetail.harmList.map((v: any) => <Fragment key={v.id}>{parse(v.popup, {})}</Fragment>) : null}
                                        </CollapseInfo>
                                    </div>
                                </div>
                            </div>

                            <div className="col-xs-12 col-sm-5 pd-r pd-unset">
                                {breachServiceActive(breachService) ? (
                                    <div className="box">
                                        <div className="box-header">
                                            <div className="box-title-container">
                                                <div className="box-title-text">
                                                    <h2 className="result-match">How do I protect myself?</h2>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="data-grid has-lines"></div>
                                        <div className="box-content">
                                            <p style={{ fontSize: "12px", padding: "1rem 0px" }}>
                                                Review and complete any open recommendations in your Action Plan to improve your ID Safety Score and protect
                                                yourself against top fraud risks presented by this breach.
                                            </p>
                                            <button
                                                className="btn-default btn-primary-outline pd-r breach-btn"
                                                style={{ color: "#007AAB", display: "block", margin: "0 auto" }}
                                                onClick={() => {
                                                    history.replace("/breaches/action-plan");
                                                }}
                                            >
                                                <span className="btn-text">Go to Action plan</span>
                                            </button>
                                        </div>
                                    </div>
                                ) : null}
                                <div className="box">
                                    <div className="box-header">
                                        <div className="box-title-container flex align-items-center">
                                            <div className="box-title-text">
                                                <h2 className="result-match">What data was affected?</h2>
                                            </div>
                                            <div className="title-icon">
                                                <button
                                                    onClick={() => {
                                                        setDialogDetail({
                                                            ...dialogDetail,
                                                            affectedDataOpen: true,
                                                        });
                                                    }}
                                                    className="header-button"
                                                    id="data-affected-info-btn"
                                                >
                                                    <img
                                                        src={InfoIcon}
                                                        className="img-info-icon"
                                                        style={{ cursor: "pointer" }}
                                                        alt="Circle with the letter 'i' in the center, signifying information"

                                                    />
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="box-content">
                                        {ifBreachDetail
                                            ? breachDetail.credentials.length &&
                                            breachDetail.credentials.map((v: any, i: number) => (
                                                <div key={v.id} className="data-grid has-lines">
                                                    {i === 0 && <div className="data-grid has-lines"></div>}
                                                    <div style={{ padding: "10px 0px" }}>
                                                        <p
                                                            style={{
                                                                fontSize: "12px",
                                                                color: "#00313c",
                                                                fontWeight: "bold",
                                                            }}
                                                        >
                                                            {v.description}
                                                        </p>
                                                    </div>
                                                </div>
                                            ))
                                            : null}
                                    </div>
                                </div>
                            </div>
                        </div>
                    ) : null}
                </div>
            </div>

            <div className="risk-rating-dialog">
                {isRiskDialogOpen && (
                    <DialogComponent dialogId="dialog-risk-rating-info" title="Breach Risk Rating Info" closeDialog={closeDialog}>
                        <BreachRiskRatingInfo closeDialog={closeDialog} />
                    </DialogComponent>
                )}

                <div>
                    {dialogDetail.saveBreachOpen && (
                        <DialogComponent dialogId="dialog-risk-rating-info" title="Breach Save Dialog" closeDialog={closeSaveBreachDialog}>
                            <BreachInfoDialog title="When should I save a breach?" getInfo={getSaveBreachInfo} closeDialog={closeSaveBreachDialog} />
                        </DialogComponent>
                    )}
                    {dialogDetail.removeBreachOpen && (
                        <DialogComponent dialogId="dialog-risk-rating-info" title="Breach Remove Dialog" closeDialog={closeRemoveBreachDialog}>
                            <BreachInfoDialog title="When should I remove a saved breach?" getInfo={getRemoveBreachInfo} closeDialog={closeRemoveBreachDialog} />
                        </DialogComponent>
                    )}
                    {dialogDetail.affectedDataOpen && (
                        <DialogComponent dialogId="dialog-risk-rating-info" title="Breach Affected Data Dialog" closeDialog={closeAffectedDataBreachDialog}>
                            <BreachInfoDialog title="What data was affected?" getInfo={getAffectedDataBreachInfo} closeDialog={closeAffectedDataBreachDialog} />
                        </DialogComponent>
                    )}
                </div>

                {confirmOpenCaseDialog && (
                    <DialogComponent hideCloseButton={true} dialogId="open-case-confirmation" title="Open a Case" closeDialog={handleOpenCaseCloseDialog}>
                        <BreachOpenCaseConfirmation
                            closeDialog={handleOpenCaseCloseDialog}
                            handleConfirm={() => {
                                if (alertItem[0]["status"] === "NOT_MINE") {
                                    handleArchive("OPEN-CASE-RESOLVED", "NOT_MINE_RESOLVED");
                                } else if (alertItem[0]["status"] === "NOT_MINE_RESOLVED") {
                                    handleArchive("RE-OPEN-CASE", "NOT_MINE");
                                } else {
                                    handleArchive("OPEN-CASE", "NOT_MINE");
                                }
                            }}
                            type={alertItem[0]["status"]}
                        />
                    </DialogComponent>
                )}
                {confirmArchiveDialog && (
                    <DialogComponent hideCloseButton={true} dialogId="open-case-confirmation" title="Open a Case" closeDialog={handleArchiveCloseDialog}>
                        <BreachArchiveConfirmation
                            closeDialog={handleArchiveCloseDialog}
                            handleConfirm={() => {
                                handleArchive("ARCHIVE", "MINE");
                            }}
                        />
                    </DialogComponent>
                )}
            </div>

            {isActionComplete && (
                <DialogComponent dialogId="dialog-action-complete" title="Breach Action Complete" closeDialog={closeActionDialog}>
                    <BreachActionComplete closeDialog={closeActionDialog} />
                </DialogComponent>
            )}
        </Fragment>
    );
}

export default BreachDetails;
